import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "app" }
const _hoisted_2 = {
  key: 0,
  class: "infinite-progress"
}
const _hoisted_3 = { id: "app" }

import { useLoadingStore } from '@/stores/loading.store';
    import { storeToRefs } from 'pinia';
    import { ref } from 'vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AppLayout',
  setup(__props) {

    const appSidebarOpened = ref(true);
    const appNavigationOpened = ref(false);
    function toggleAppNavigation(isOpen: boolean) { appNavigationOpened.value = isOpen; }
    function onAppSidebarToggled(sidebarState: boolean) { appSidebarOpened.value = sidebarState; }
    const loading = useLoadingStore();
    const { isLoading } = storeToRefs(loading);

return (_ctx: any,_cache: any) => {
  const _component_navbar_layout = _resolveComponent("navbar-layout")!
  const _component_sidebar_layout = _resolveComponent("sidebar-layout")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(_component_navbar_layout, { appSidebarOpened: appSidebarOpened.value }, null, 8, ["appSidebarOpened"]),
    _createVNode(_component_sidebar_layout, {
      onAppSidebarToggled: _cache[0] || (_cache[0] = ($event: any) => (onAppSidebarToggled($event)))
    }),
    _createElementVNode("section", {
      class: "app-section",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleAppNavigation(false)))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}
}

})